import { useIsLoggedIn } from "../../data/loggedIn";
import AuthNavigator from "../AuthNavigator";
import LoggedInNavigator from "../LoggedInNavigator";

export default function RootNavigator() {
    const loggedIn = useIsLoggedIn();
    return loggedIn ? <LoggedInNavigator /> : <AuthNavigator />;
}
